module.exports = __webpack_public_path__ + "img/Transpordiamet_logo_valge_est.6172a511.svg";